<template>
  <div>
    <el-form ref="topicForm" :model="feeModel" :validate-on-rule-change="false">
      <el-table :data="feeList" class="shadow-none">
        <el-table-column :label="$t('Base.language')" width="160">
          <template #default="{ row, $index }">
            <el-form-item :prop="`[${$index}].k`">
              <el-select v-model="row.k">
                <el-option
                  v-for="lang in langOptions"
                  :key="lang.value"
                  :value="lang.value"
                  :label="lang.label"
                />
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column :label="$t('Base.content')">
          <template #default="{ row, $index }">
            <el-form-item :prop="`[${$index}].v`">
              <el-input type="textarea" v-model="row.v" :rows="1"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column width="80">
          <template #header="scope">
            <el-button
              size="small"
              @click="addItem()"
              :disabled="disableAdd(scope) || !$hasPermission('post') || disabled"
            >
              {{ $t('Base.add') }}
            </el-button>
          </template>
          <template #default="{ row }">
            <el-button
              size="small"
              :disabled="!$hasPermission('delete') || disabled"
              @click="delItem(row)"
            >
              {{ $t('Base.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
  </div>
</template>

<script>
import { computed, defineComponent, onMounted, ref, watch, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import useProtocolEnums from '@/hooks/useProtocolEnums'

export default defineComponent({
  name: 'AlarmI18nNames',
  emits: ['update:list'],
  props: {
    list: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  setup(props, context) {
    let feeList = ref(props.list)
    let feeModel = computed(() => {
      let model = {}
      feeList.value.forEach((v, k) => {
        model[k] = v
      })
      return model
    })

    const { t } = useI18n()

    const addItem = () => {
      let tmp = {
        k: '',
        v: '',
      }
      feeList.value.push(tmp)
    }

    const disableAdd = () => {
      return feeList.value.length >= 10
    }

    const delItem = (row) => {
      feeList.value.forEach((v, k) => {
        if (v === row) {
          feeList.value.splice(k, 1)
        }
      })
    }

    watch(feeList.value, (v) => {
      context.emit('update:list', v)
    })
    watch(
      () => props.list,
      (newList) => {
        feeList.value = [...newList]
      },
      { immediate: true }, // 立即执行，确保初始加载时也同步
    )

    onMounted(() => {})

    const { langOptions } = useProtocolEnums()
    return {
      feeList,
      addItem,
      disableAdd,
      delItem,
      feeModel,
      langOptions,
    }
  },
})
</script>

<style lang="scss" scoped>
.el-form-item {
  margin: 0;
}
</style>
